module.exports = __webpack_public_path__ + "img/1.7d4c9f41.svg";